/*! Albatross (C) GrandPad, Inc */

import {LoginVueRoot} from './root';
import '../shared/validation';

LoginVueRoot.$mount('#gpal-app-root');
